import React from 'react';
import { Container } from './styles';

interface SquareLoaderProps {
  customClass: string;
}

const SquareLoader = (props: SquareLoaderProps) => {
  const { customClass } = props;

  return (
    <Container>
      <span className={`loading-bars ${customClass}`}>
        <span />
        <span />
        <span />
      </span>
    </Container>
  );
};

export default SquareLoader;
